import AdminLayout from '../../components/layout/AdminLayout';
import AnnouncementsManager from '../../components/AnnouncementsManager';

export default function AnnouncementsPage() {
  return (
    <AdminLayout>
      <AnnouncementsManager />
    </AdminLayout>
  );
}
